import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthProvider";

const AuthRoute = () => {
    const auth = useAuth();

    if (!auth.sesiune)
        return <Navigate to="/openSession" />;

    return <Outlet />;
};

export default AuthRoute;
